/*
 *   File : history.js
 *   Author : https://evoqins.com
 *   Description : Activity history list tab file
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useState } from 'react';

//Custom components
import { CustomDataTable } from '../../../Components/DataTable';
import { EmptyScreen } from '../../../Components/Others';

const ITEMS_PER_PAGE = 100;

const ActivityHistory = (props) => {

    const [currentPage, setCurrentPage] = useState(1);

    // handle table page change 
    const _handleTablePageChange = (page_num) => {
        setCurrentPage(page_num);
    };

    // Leads data table column 
    const TABLE_COLUMN = [
        {
            name: 'Date & time',
            selector: row => row.created,
            width: "240px"
        },
        {
            name: 'Activity',
            selector: row => row.note,
            width: "540px"
        },
    ];

    return (
        <div className='padding-34px-tb '>
            <div className='padding-32px-lr'>
                <h4 className='mb-0 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                    Activity log list
                </h4>
            </div>

            {/* Activity history list table */}
            {props.activityData.data.length !== 0 ?
                <div className='e-data-table-wrapper-default-updated padding-26px-top padding-32px-bottom'>
                    <CustomDataTable columns={TABLE_COLUMN}
                        data={props.activityData.data}
                        pagination={props.activityData.total_count > ITEMS_PER_PAGE ? true : false}
                        paginationPerPage={ITEMS_PER_PAGE}
                        lastPage={props.activityData.total_page}
                        paginationTotalRows={props.activityData.total_count}
                        paginationDefaultPage={props.activityData.current_page}
                        onChangePage={_handleTablePageChange} />
                </div>
                :
                <EmptyScreen width={120}
                    height={120}
                    image={require('../../../Assets/Image/NotFound/no-data.png')}
                    title='No data found'
                />
            }
        </div>
    )
}

export default ActivityHistory;
